import React from 'react';

const LoadingComponent = () => {
    return (
        <div className="loading-container">
            <div className="loader"></div>
        </div>
    );
};

export default LoadingComponent;
